import React from 'react';
import { Box, IconButton, Typography, Stack, Button } from '@material-ui/core';
import {
  Close,
  Forum,
  GraphicEq,
  Face,
  LockOutlined,
} from '@material-ui/icons';
import { CHAT_GPT_DARK } from '../constants';

const VoiceOnboarding = ({ isDarkMode, onClose, onContinue }) => (
  <Box
    sx={{
      position: 'absolute',
      inset: 0,
      zIndex: 200,
      bgcolor: isDarkMode ? CHAT_GPT_DARK : '#ffffff',
      display: 'flex',
      flexDirection: 'column',
      p: 3,
      overflowY: 'auto',
    }}
  >
    <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 4 }}>
      <IconButton onClick={onClose} size="small" sx={{ color: isDarkMode ? 'white' : 'black' }}>
        <Close />
      </IconButton>
    </Box>

    <Typography
      variant="h5"
      fontWeight="bold"
      align="center"
      sx={{ mb: 5, color: isDarkMode ? 'white' : 'black' }}
    >
      Say hello to Voice
    </Typography>

    <Stack spacing={4} sx={{ flex: 1, px: 1 }}>
      {[
        {
          icon: <Forum style={{ color: '#10a37f' }} />,
          title: 'Natural conversations',
          desc: 'Senses and responds to interruptions, humor, and more.',
        },
        {
          icon: <GraphicEq style={{ color: '#10a37f' }} />,
          title: 'Multiple voices',
          desc: 'Offers an expanded set of voices to choose from.',
        },
        {
          icon: <Face style={{ color: '#10a37f' }} />,
          title: 'Personalized to you',
          desc: 'Can use memory and custom instructions to shape responses.',
        },
        {
          icon: <LockOutlined style={{ color: '#10a37f' }} />,
          title: "You're in control",
          desc: 'Audio recordings are saved, and you can delete them at any time.',
        },
      ].map((item, idx) => (
        <Stack key={idx} direction="row" spacing={2} alignItems="flex-start">
          <Box sx={{ mt: 0.5 }}>{item.icon}</Box>
          <Box>
            <Typography
              variant="subtitle2"
              fontWeight="bold"
              sx={{ color: isDarkMode ? 'white' : 'black' }}
            >
              {item.title}
            </Typography>
            <Typography variant="caption" sx={{ color: 'gray', lineHeight: 1.2 }}>
              {item.desc}
            </Typography>
          </Box>
        </Stack>
      ))}
    </Stack>

    <Box sx={{ mt: 'auto', pt: 4, textAlign: 'center' }}>
      <Typography variant="caption" sx={{ color: 'gray', display: 'block', mb: 3, px: 2 }}>
        SEFI can make mistakes – check important info. Usage limits may change.
      </Typography>
      <Button
        variant="contained"
        fullWidth
        onClick={onContinue}
        sx={{
          bgcolor: 'black',
          color: 'white',
          borderRadius: '25px',
          py: 1.5,
          textTransform: 'none',
          fontSize: '1rem',
          fontWeight: 'bold',
          '&:hover': { bgcolor: '#333' },
        }}
      >
        Continue
      </Button>
    </Box>
  </Box>
);

export default VoiceOnboarding;
